import { call, put, takeEvery } from 'redux-saga/effects';
import { getTargetFiles, getNextResults, delay } from '../utils/helper';
import axios from 'axios';
import { url } from '../config';
import {
  billDraftingActions,
  storeTitleContent,
  storeTitles,
  storeTextContent,
  loadingContent,
} from '../actions/billDraftingAction';

function getAllTitlesResponse() {
  return axios.get(url + '/api/billDrafting/codeTitle/');
}
function getTitleContentResponse(title) {
  return axios.get(`${url}/api/billDrafting/codeTitle/${title}/`);
}

function getSectionContentResponse(textType, section) {
  return axios.get(`${url}/api/billDrafting/code${textType}/${section}/`);
}

function* loadAllTitles(action) {
  if (action !== undefined) {
    try {
      const response = yield call(getAllTitlesResponse);
      const { data } = response;
      yield put(storeTitles(data));
    } catch (e) {
      console.log(e);
    }
  }
}

function* loadTitleContent(action) {
  if (action !== undefined) {
    try {
      const response = yield call(getTitleContentResponse, action.title);
      const { data } = response;
      yield put(storeTitleContent(data));
    } catch (e) {
      console.log(e);
    }
  }
}

function* loadTextContent(action) {
  if (action !== undefined) {
    try {
      yield put(loadingContent(true));
      const response = yield call(
        getSectionContentResponse,
        action.textType,
        action.section
      );
      const { data } = response;
      yield put(storeTextContent(data));
      yield put(loadingContent(false));
    } catch (e) {
      console.log(e);
    }
  }
}

function* billDraftingAPI() {
  yield takeEvery(billDraftingActions.GET_TITLES, loadAllTitles);
  yield takeEvery(billDraftingActions.GET_TITLE_CONTENT, loadTitleContent);
  yield takeEvery(billDraftingActions.GET_TEXT_CONTENT, loadTextContent);
}

export default billDraftingAPI;
